import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const Qatar: Country = {
    identifier: "Qatar",
    name: "Qatar",
    countryCode: "QA",
    group: CountryGroup.ASIA,
    isUNMember: true,
    flag: "🇶🇦",
    svgPath: "m 618.77875,392.0844 -0.253,0.063 -0.237,0.067 -0.198,-0.002 -0.16,-0.026 -0.106,-0.065 -0.204,-0.26 -0.144,-0.337 0.089,-0.188 0.03,-0.117 -0.195,-0.89 -0.063,-0.685 0.023,-0.14 0.111,-0.162 0.186,-0.358 0.099,-0.345 0.278,-0.798 0.295,-0.308 0.432,-0.226 0.356,0.442 0.432,0.337 0.083,0.377 -0.127,0.307 -0.118,0.486 0.071,0.224 0.026,0.194 0.117,0.325 0.114,0.421 0.019,0.293 -0.061,0.271 -0.151,0.228 -0.296,0.684 -0.088,0.071 z",
}
